import { localStorageService } from '@/services/LocalStorageService'
import numeral from 'numeral'

/**
 * Loads an item from the local storage by key.
 *
 * @export
 * @param {string} key
 * @param {*} fallback
 * @returns {*}
 */
export function load (key, fallback) {
  try {
    let item = localStorageService.getItem(key)
    return item ? window.JSON.parse(item) : fallback
  } catch (err) {
    return fallback
  }
}

/**
 * Persists a value in local storage.
 *
 * @export
 * @param {string} key
 * @param {*} [value={}]
 */
export function persist (key, value = {}) {
  localStorageService.setItem(key, window.JSON.stringify(value))
}

/**
 * Removes an item from the local storage by key.
 *
 * @export
 * @param {string} key
 */
export function forget (key) {
  localStorageService.removeItem(key)
}

export function formatmileage (value) {
  return numeral(value).format('000000')
}

export function findmileageDifference (suggestion, mileage) {
  const sign = mileage > suggestion ? '-' : '+'
  return sign + numeral(suggestion).difference(mileage)
}

export function waitFor (time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time)
  })
}
